import React, { useState } from "react";
import { t } from "../../../../utils/i18n";
import { copyToClipboard, truncateAddress } from "../Helper";

const StoreInfo = ({ storeId, walletAddress }) => {
  const [copiedStoreId, setCopiedStoreId] = useState(false);
  const [copiedWalletAddress, setCopiedWalletAddress] = useState(false);

  return (
    <div className="doc-info-box">
      <div className="doc-info-item">
        <label>{t("store_integrations.widget.store_id")}</label>
        <div className="doc-copy-field">
          <span className="doc-text">{truncateAddress(storeId)}</span>
          <button
            className="copy-btn"
            onClick={() => copyToClipboard(storeId, setCopiedStoreId)}
          >
            {copiedStoreId ? t("store_integrations.widget.copied") : t("store_integrations.widget.copy")}
          </button>
        </div>
      </div>
      <div className="doc-info-item">
        <label>{t("store_integrations.widget.wallet_address")}</label>
        <div className="doc-copy-field">
          <span className="doc-text">{truncateAddress(walletAddress)}</span>
          <button
            className="copy-btn"
            onClick={() =>
              copyToClipboard(walletAddress, setCopiedWalletAddress)
            }
          >
            {copiedWalletAddress ? t("store_integrations.widget.copied") : t("store_integrations.widget.copy")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoreInfo;
